<div class="layout-container" [class.mobile]="mobileQuery.matches">
  <ng-content select="[slot='header']"></ng-content>
  <div class="content-wrapper">
    <div class="content">
      <ng-content select="[slot='content']"></ng-content>
    </div>
  </div>
</div>
